/* eslint-disable react/prop-types */
import React, { Component } from 'react'
import { withTranslation } from 'react-i18next'
import DraftEditor from '../common/form/DraftEditor'

// ASSETS
import './AdminEducationLesson.scss'

class AdminEducationLesson extends Component {
  constructor(props) {
    super(props)

    this.state = {
      id: props.lesson.id ? props.lesson.id : -1,
      order: props.lesson.order,
      name: props.lesson.name ? props.lesson.name : '',
      video_url: props.lesson.video_url ? props.lesson.video_url : '',
      description: props.lesson.description ? props.lesson.description : '',
      lessonHoverActive: false,
    }
  }

  onMouseEnter = () => {
    this.setState({ lessonHoverActive: true })
  }

  onMouseLeave = () => {
    this.setState({ lessonHoverActive: false })
  }

  handleInputChange = event => {
    const { sendLessonData } = this.props
    this.setState(
      {
        [event.target.name]: event.target.value,
      },
      () => {
        sendLessonData(this.state)
      }
    )
  }

  handleStatefulEditorChange = htmlString => {
    const { sendLessonData } = this.props
    this.setState(
      {
        description: htmlString,
      },
      () => {
        sendLessonData(this.state)
      }
    )
  }

  render() {
    const { name, video_url, description, lessonHoverActive } = this.state
    const { lesson, deleteLesson, isEditModal, t } = this.props
    return (
      <div
        id='AdminEducationLesson'
        className='col-md-11 animated fadeIn'
        onMouseEnter={this.onMouseEnter}
        onMouseLeave={this.onMouseLeave}
      >
        {lessonHoverActive && !isEditModal && (
          <button
            className='delete-btn animation-shrink'
            onClick={() => deleteLesson(lesson)}
          >
            <i className='fa fa-times' />
          </button>
        )}
        <div className='row'>
          <div className='col-md-6'>
            <div className='form-group'>
              <label htmlFor='name'>{t('education.lesson.nameLabel')}</label>
              <input
                type='text'
                name='name'
                className='form-control'
                id='name'
                placeholder={t('education.lesson.namePlaceholder')}
                onChange={this.handleInputChange}
                value={name}
              />
            </div>
          </div>
          <div className='col-md-6'>
            <div className='form-group'>
              <label htmlFor='video_url'>{t('education.lesson.videoUrlLabel')}</label>
              <input
                type='text'
                name='video_url'
                className='form-control'
                id='video_url'
                placeholder={t('education.lesson.videoUrlPlaceholder')}
                onChange={this.handleInputChange}
                value={video_url}
              />
            </div>
          </div>
          <div className='col-md-12'>
            <div className='form-group'>
              <label htmlFor='description'>{t('common.field.description')}</label>
              {/* <MyStatefulEditor
                name="description"
                content={description}
                onChange={this.handleStatefulEditorChange}
              />
               */}
              <DraftEditor
                placeholder={t('education.lesson.contentPlaceholder')}
                content={description}
                sendEditorData={this.handleStatefulEditorChange}
              />
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default withTranslation()(AdminEducationLesson)
